import { render, staticRenderFns } from "./staticStructureTable.vue?vue&type=template&id=6d7f7d0d&"
import script from "./staticStructureTable.vue?vue&type=script&lang=js&"
export * from "./staticStructureTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports